export default __webpack_public_path__ + "static/media/Confectionery6.396cf4dc.png";